import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { deleteUnsubscribeAll } from '../../../api/channels';

import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

import { REQUEST } from '../../../constants/request';

export const removeSubscriptions = createAsyncThunk(
  'channels/removeSubscriptions',
  async ({ path }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await deleteUnsubscribeAll(
        { path },
        {
          cancelToken: source.token,
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const state = getState();

      return !(
        state.channels.channels.channel.actions.removeSubscription.request[
          generateChannelCIDKey(path)
        ]?.loading === REQUEST.pending
      );
    },
  },
);

export const removeSubscriptionsExtraReducers = builder => {
  builder
    .addCase(removeSubscriptions.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.channels.channel.actions.removeSubscription.request,
        action,
        generateChannelCIDKey(action.meta.arg.path),
      );
    })
    .addCase(removeSubscriptions.fulfilled, (state, action) => {
      const channelCIDKey = generateChannelCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.channels.channel.actions.removeSubscription.request[
          channelCIDKey
        ],
        action,
        () => {
          state.channels.channel.byId[channelCIDKey] = action.payload;
        },
      );
    })
    .addCase(removeSubscriptions.rejected, (state, action) => {
      handleRequestRejection(
        state.channels.channel.actions.removeSubscription.request[
          generateChannelCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
